"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeSizeObserver = void 0;
class SizeObserver {
    constructor(element, propertyName, axis, includePadding, includeFullSize) {
        this.element = element;
        this.propertyName = propertyName;
        this.axis = axis;
        this.includePadding = includePadding;
        this.includeFullSize = includeFullSize;
        this.axis = this.axis || 'both';
        this.propertyName = this.propertyName || 'size-observer';
        const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                const { width, height } = this.getHeightWidth(entry);
                this.setElementProperties(width, height);
            }
        });
        resizeObserver.observe(element);
    }
    getHeightWidth(entry) {
        var _a, _b;
        if (this.includeFullSize && entry.target) {
            return { width: (_a = entry.target.scrollWidth) !== null && _a !== void 0 ? _a : 0, height: (_b = entry.target.scrollHeight) !== null && _b !== void 0 ? _b : 0 };
        }
        if (this.includePadding && entry.borderBoxSize) {
            return { width: entry.borderBoxSize[0].inlineSize, height: entry.borderBoxSize[0].blockSize };
        }
        return { width: entry.contentRect.width, height: entry.contentRect.height };
    }
    setElementProperties(width, height) {
        if (this.axis == 'y' || this.axis == 'both') {
            this.element.style.setProperty(`--${this.propertyName}-height`, `${height}px`);
        }
        if (this.axis == 'x' || this.axis == 'both') {
            this.element.style.setProperty(`--${this.propertyName}-width`, `${width}px`);
        }
    }
}
// Initializing the SizeObserver class
function initializeSizeObserver() {
    document.querySelectorAll('[data-js-sizeobserver]').forEach((element) => {
        const axis = element.getAttribute('data-js-sizeobserver-axis');
        const propertyName = element.getAttribute('data-js-sizeobserver');
        const includePadding = element.hasAttribute('data-js-sizeobserver-use-box-size');
        const includeFullSize = element.hasAttribute('data-js-sizeobserver-element-full-size');
        new SizeObserver(element, propertyName, axis, includePadding, includeFullSize);
    });
}
exports.initializeSizeObserver = initializeSizeObserver;
